import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
  },
  formContainer: {
    maxWidth: '800px',
    width: '100%',
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  cancelBtn: {
    marginRight: '10px',
  },
});
